<template>
  <div id="J_ushk" class="ushk ushk-index">
    <div class="ushk-container">
      <div class="ushk-box">
        <ushk-header>
        </ushk-header>
         <!-- <ushk-price></ushk-price> -->
        <div class="ushk-page">
          <div class="ushk-wrap ushk-wrap-main">
            <home></home>
          </div>
        </div>
      </div>
      <ushk-footer></ushk-footer>
    </div>
    <backtop></backtop>
  </div>
</template>
<style type="text/css" lang="scss">
  @import './style/index.scss';
</style>
<script>
  import Home from './pages/home'
  export default {
    name: 'appStatic',
    computed: {

    },
    components: {
      Home
    },
    created () {

    }
  }
</script>



// WEBPACK FOOTER //
// App.vue?6202506e